<div
  [ngClass]="{ 'random-bg': true, 'rounded-full': round, 'rounded-[5px]': !round }"
  [style.backgroundColor]="randomBgColor"
  class="flex justify-center items-center"
  [style.width.px]="isMediumScreen ? 35 : size"
  [style.height.px]="isMediumScreen ? 35 : size"
>
  <span class="font-[800] text-[10px] md:text-[14px] text-slate-600">{{
    getInitials(text)
  }}</span>
</div>
